import React from 'react';
import { Col } from '@amzn/stencil-react-components/layout';
import ChannelTypeForm from './ChannelTypeForm';
import ScheduleForm from './ScheduleForm';
import SelectSegment from './SelectSegment';
import SelectTemplate from './SelectTemplate';
import { useSelector } from 'react-redux';
import { multiCampaignFormSubmissionSelector } from '../../selectors/selectors';

const CampaignDetailsForm = ({ formData, readonly }) => {
  const { content, segment, schedule, platform, campaignId, isValid } = formData;
  const isFormSubmitted = useSelector(multiCampaignFormSubmissionSelector);
  return (
    <Col
      width="100%"
      padding="S200"
      backgroundColor="#f1f4f7"
      data-testid="campaign-form-section"
      key={campaignId}
      style={{
        border: '1px solid #ccc',
        display: 'grid',
        gap: '1rem',
        gridTemplateColumns: '1fr 1fr 1.7fr 0.7fr',
      }}
      className={isFormSubmitted && !isValid ? 'form-error' : ''}
    >
      <Col key={`select-segment-${campaignId}`}>
        <SelectSegment data={segment} id={campaignId} readonly={readonly} />
      </Col>

      <Col key={`select-template-${campaignId}`}>
        <SelectTemplate data={content} id={campaignId} readonly={readonly} />
      </Col>

      <Col key={`schedule-form-${campaignId}`}>
        <ScheduleForm data={schedule} id={campaignId} readonly={readonly} />
      </Col>

      <Col key={`channel-form-${campaignId}`}>
        <ChannelTypeForm channelData={platform} id={campaignId} readonly={readonly} />
      </Col>
    </Col>
  );
};

export default CampaignDetailsForm;
